import { AVOIDED_EMOJI_VERSION } from 'globalConstants'

import { EmojiProps } from './EmojiPicker'

export const filterEmoji = (emoji: EmojiProps) =>
  emoji.added_in !== AVOIDED_EMOJI_VERSION && !emoji.unified.includes('-')
